import { CircleButton, Flex, Icon, Title } from '@bb/elements-web';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import AppointmentBookingInternalContext from './AppointmentBookingInternalContext';
import HeaderButtons from './HeaderButtons';

const Header: React.FC = () => {
  const { listing } = useContext(AppointmentBookingInternalContext);
  const history = useHistory();
  const goToListingViewPage = () =>
    history.push(`/listing/${listing?.id}/view`);
  if (!listing) return null;
  return (
    <StyledFlex align="center">
      <Flex gap="small" align="center">
        <CircleButton
          dataCy="bookShowing-back-button"
          type="default"
          size="large"
          onClick={goToListingViewPage}
          icon={<Icon icon="fullArrowLeftOutlined" size={16} color="inherit" />}
        />
        <Title
          dataCy={'bookShowing-title-address'}
          level={4}
          thickness="normal"
        >
          {listing!.line1} {listing!.line2} &gt; Book Showing
        </Title>
      </Flex>
      <HeaderButtons goToListingViewPage={goToListingViewPage} />
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  width: 100%;
  flex-wrap: wrap;
  & > div:first-child {
    flex-grow: 1;
  }
`;

export default Header;
